module.exports = __webpack_public_path__ + "img/check_animated.ce1a0abe.svg";